import { Modal } from 'react-bootstrap'
import { KTSVG } from '../../../_metronic/helpers'
import { PortfolioView } from './ViewEEPortfolio'
import { useIsMutating } from 'react-query'
import Toast, { ToastType } from '../../../utils/toast'
import {
  RemoveEePortfolioMutation,
  RemoveEePortfolioMutationVariables,
  useGetEePortfoliosQuery,
  useRemoveEePortfolioMutation,
} from '../../../generated/graphql'
import { graphqlRequestClient, queryClient } from '../../../queries/client'

type Props = {
  showRemoveModal: boolean
  toggleRemoveModal: () => void
  portfolio: any
}

function RemoveEEPortfolio({ showRemoveModal, toggleRemoveModal, portfolio: port }: Props) {
  const removeMutate = useRemoveEePortfolioMutation<Error>(
    graphqlRequestClient,
    {
      onSuccess: (data: RemoveEePortfolioMutation, _variables: RemoveEePortfolioMutationVariables, _context: unknown) => {
        queryClient.invalidateQueries(useGetEePortfoliosQuery.getKey())
        Toast(data.removeEEPortfolio.message, ToastType.success)
        toggleRemoveModal()
      },
      onError: (error: any) => Toast(error.response.errors[0].message, ToastType.error),
    },
    {}
  )

  function handleSubmit(e: any) {
    e.preventDefault()
    e.stopPropagation()
    removeMutate.mutate({ input: { id: port.id } })
  }

  return (
    <Modal
      id='kt_modal_remove_portfolio'
      aria-hidden='true'
      show={showRemoveModal}
      onHide={toggleRemoveModal}
      dialogClassName='modal-dialog modal-dialog-centered mw-700px'
    >
      <form onSubmit={handleSubmit}>
        <Modal.Header className='p-2'>
          <Modal.Title className='ps-5'>Remove Portfolio</Modal.Title>
          <button
            className='btn btn-sm btn-icon btn-active-light-primary'
            type='button'
            data-bs-toggle='tooltip'
            title='Close'
            onClick={toggleRemoveModal}
          >
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
          </button>
        </Modal.Header>
        <Modal.Body className='p-0'>
          <PortfolioView portfolio={port} />
        </Modal.Body>
        <Modal.Footer className='p-2'>
          <div className='d-flex justify-content-start w-100'>
            <p className='mb-0'>Are you sure you want to remove this portfolio?</p>
          </div>
          <div className='d-flex justify-content-end'>
            <button type='button' className='btn btn-sm btn-secondary me-3' onClick={toggleRemoveModal}>
              Cancel
            </button>
            <button type='submit' className='btn btn-sm btn-primary' disabled={useIsMutating() > 0}>
              {useIsMutating() === 0 && 'Remove Portfolio'}
              {useIsMutating() > 0 && (
                <span className='indicator-progress' style={{ display: 'block' }}>
                  Please wait... <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          </div>
        </Modal.Footer>
      </form>
    </Modal>
  )
}

export default RemoveEEPortfolio
